import { render, staticRenderFns } from "./WelcomeComponent.vue?vue&type=template&id=64031d24"
import script from "./WelcomeComponent.vue?vue&type=script&lang=js"
export * from "./WelcomeComponent.vue?vue&type=script&lang=js"
import style0 from "./WelcomeComponent.vue?vue&type=style&index=0&id=64031d24&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports